import { classNames } from "../utils/styling-utils"
import { useEffect, useState } from "react"
import { Link } from "react-router"
import { TEnkIwpReport, EnkIWPServerReports as ApiReports } from "../api/api-iwp-server"
import EnkPageContainer from "../components/page-container"
import EnkContentLoadingAndError from "../components/error-box"
import { useAuth } from "../auth/use-auth"

const statuses = {
  active: { class: "text-green-700 bg-green-50 ring-green-600/20", text: "Actief" },
  notFound: { class: "text-gray-600 bg-gray-50 ring-gray-500/10", text: "Niet gevonden" },
}

export default function EnkReports() {
  const [reports, setReports] = useState<TEnkIwpReport[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)
  const { getCurrentGroupId } = useAuth()

  useEffect(() => {
    // Fetch reports
    ApiReports.getList(getCurrentGroupId())
      .then((reports) => {
        setReports(reports)
        setError(null) // Clear any previous errors
        setLoading(false)
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error)
        setError("Er is een fout opgetreden bij het ophalen van de rapporten.")
      })
  }, [getCurrentGroupId])

  return (
    <EnkPageContainer>
      <EnkContentLoadingAndError loading={loading} error={error}>
        <ul role="list" className="divide-y divide-gray-100">
          {reports.map((report, idx) => (
            <li key={idx} className="flex items-center justify-between gap-x-6 py-5">
              <div className="min-w-0">
                <div className="flex items-start gap-x-3">
                  <p className="text-sm/6 font-semibold text-gray-900">{report.name}</p>
                  <p
                    className={classNames(
                      statuses[report.status].class,
                      "mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                    )}
                  >
                    {statuses[report.status].text}
                  </p>
                </div>
                <div className="mt-1 flex items-center gap-x-2 text-xs/5 text-gray-500">
                  <p className="whitespace-nowrap">{report.description}</p>
                </div>
              </div>
              <div className="flex flex-none items-center gap-x-4">
                <Link
                  to={"/report/" + encodeURIComponent(report.reportFile || "")}
                  className="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
                >
                  Toon rapport<span className="sr-only">, {report.name}</span>
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </EnkContentLoadingAndError>
    </EnkPageContainer>
  )
}
